export default {
  linkExpired: {
    id: 'bo_sellers_customer_care_attachment_link_expired',
    defaultMessage: 'This link has expired, please refresh the page',
  },
}
